module.exports = __webpack_public_path__ + "static/media/logo-mkt-360.c454276a.png";